module.exports = __webpack_public_path__ + "img/pic8.72ac63f3.png";